import Image from 'next/image';
import styles from './CardAvatar.module.scss';
import { imageLoader } from '../../utilities/imageLoader';

type ArticleCardAvatar = {
  authorName: string;
  authorImageSrc?: string;
  isHero: boolean;
  isTileWithImage: boolean;
};

export const CardAvatar = ({ authorName, isTileWithImage, isHero, authorImageSrc }: ArticleCardAvatar) => (
  <div
    className={`${styles.root} ${isTileWithImage ? styles['root-tile-wit-image'] : ''} ${
      isHero ? styles['root-hero'] : ''
    }`}
  >
    <div className={styles.image}>
      <Image
        src={`${authorImageSrc}?fm=webp&w=64&&q=100`}
        width="64"
        height="56"
        loading="lazy"
        alt="avatar"
        unoptimized
        loader={imageLoader}
      />
    </div>
    <p style={{ margin: '0 0 0 6px', fontWeight: 600 }}>{authorName}</p>
  </div>
);
